import { render, staticRenderFns } from "./WGWorldPlaceContainer.vue?vue&type=template&id=f8de3012&scoped=true&"
import script from "./WGWorldPlaceContainer.vue?vue&type=script&lang=js&"
export * from "./WGWorldPlaceContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../contacts/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8de3012",
  null
  
)

export default component.exports